import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import cmpLogo from "../../../images/cmp_logo.png";
import { commonStyles } from "../../common/commonStyles";

interface BaseAuthPageProps {
  children: ReactNode;
  logoSubtitle: string;
}

const BaseAuthPage = ({ children, logoSubtitle }: BaseAuthPageProps) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F9FAFB",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "560px",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)",
            p: 5, // This is equivalent to 32px padding
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={cmpLogo}
            alt="CMP Logo"
            sx={{
              maxHeight: 80,
              width: "auto",
              maxWidth: "100%", // Prevent logo from getting too close to edges
              height: "auto", // Allow height to adjust based on width
              pb: 1, // margin bottom for spacing between logo and content
            }}
          />
          <Typography
            sx={{
              fontWeight: "bold",
              pb: 5,
              fontSize: commonStyles.fontSizes.xlarge,
            }}
          >
            {logoSubtitle}
          </Typography>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default BaseAuthPage;
